import { validations } from './validations';

/**
 * Questions about beer events and travel
 */
export const beerEventsQuestions = [
  {
    id: 'went-to-beer-event',
    question: 'Você já foi a algum evento cervejeiro?',
    type: 'radio',
    options: [
      { value: 'sim, vou frequentemente', label: 'Sim, vou frequentemente' },
      { value: 'já fui, mas poucas vezes', label: 'Já fui, mas poucas vezes' },
      { value: 'nunca fui', label: 'Nunca fui' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'nunca fui') {
        return 'why-never-went-to-beer-event';
      }
      return 'beer-event-price-range';
    },
    validation: validations.required,
  },
  {
    id: 'why-never-went-to-beer-event',
    question: 'Por que você nunca foi a um evento cervejeiro?',
    type: 'radio',
    options: [
      { value: 'localização', label: 'Localização' },
      { value: 'preço das cervejas', label: 'Preço das cervejas' },
      { value: 'preço do ingresso', label: 'Preço do ingresso' },
      { value: 'não gosto', label: 'Não gosto' },
      { value: 'não tenho companhia', label: 'Não tenho companhia' },
      { value: 'bebo pouco e acho que não compensa para mim', label: 'Bebo pouco e acho que não compensa para mim' },
    ],
    nextQuestion: 'beer-travel',
    validation: validations.required,
  },
  {
    id: 'beer-event-price-range',
    question: 'Considere um evento que tenha diversos estilos e cervejarias que você gosta. Quanto você estaria disposto a pagar no ingresso se fosse OPEN BAR (Consumo à vontade)?',
    type: 'radio',
    options: [
      { value: 'até 100', label: 'Até R$ 100' },
      { value: 'até 200', label: 'Até R$ 200' },
      { value: 'até 300', label: 'Até R$ 300' },
      { value: 'até 400', label: 'Até R$ 400' },
      { value: 'até 500', label: 'Até R$ 500' },
      { value: 'mais de 500', label: 'Mais de R$ 500' },
    ],
    validation: validations.required,
  },
  {
    id: 'beer-event-price-range-without-consumption',
    question: 'E no mesmo evento, quanto você estaria disposto a pagar por um ingresso que não inclua consumo, ou seja, com doses cobradas à parte?',
    type: 'radio',
    options: [
      { value: 'até r$ 20', label: 'Até R$ 20' },
      { value: 'até r$ 50', label: 'Até R$ 50' },
      { value: 'até r$ 100', label: 'Até R$ 100' },
      { value: 'até r$ 150', label: 'Até R$ 150' },
      { value: 'até r$ 200', label: 'Até R$ 200' },
      { value: 'mais de r$ 200', label: 'Mais de R$ 200' },
    ],
    validation: validations.required,
  },
  {
    id: 'beer-event-most-valued-thing',
    question: 'Além das cervejas, o que você mais valoriza em um evento cervejeiro?',
    type: 'checkbox',
    options: [
      { value: 'atrações musicais', label: 'Atrações musicais' },
      { value: 'venda de souveniers / itens colecionáveis', label: 'Venda de souveniers / itens colecionáveis' },
      { value: 'workshops / conteúdo sobre cervejas', label: 'Workshops / conteúdo sobre cervejas' },
      { value: 'degustações guiadas', label: 'Degustações guiadas' },
      { value: 'opções de alimentação', label: 'Opções de alimentação' },
      { value: 'opções de outras bebidas além de cerveja', label: 'Opções de outras bebidas além de cerveja' },
      { value: 'espaco bonito / instagramável', label: 'Espaço bonito / instagramável' },
    ],
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
  },
];
